var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-controls", attrs: { id: "header__controls" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-7 col-md-8 col-8 left-side" }, [
            _c(
              "div",
              { staticClass: "form-inline" },
              [
                _c("div", { staticClass: "input-group top-search" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery"
                      },
                      {
                        name: "debounce",
                        rawName: "v-debounce:500ms",
                        value: _vm.setQuery,
                        expression: "setQuery",
                        arg: "500ms"
                      }
                    ],
                    ref: "searchQuery",
                    staticClass: "form-control media-calls-search",
                    attrs: {
                      type: "text",
                      "debounce-events": ["keyup"],
                      placeholder: "Search audit logs...",
                      id: "search-query"
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      click: function($event) {
                        return _vm.$refs.searchQuery.select()
                      },
                      keypress: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getAuditLogs()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchQuery = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-group-append cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.getAuditLogs()
                        }
                      }
                    },
                    [_vm._m(0)]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "report-type audit-log-user" },
                  [
                    _c("multiselect", {
                      ref: "auditLogUser",
                      attrs: {
                        options: _vm.allUsers,
                        "show-labels": false,
                        multiple: true,
                        "allow-empty": false,
                        placeholder: "Filter by user",
                        "track-by": "id",
                        label: "name",
                        "open-direction": "bottom"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection",
                          fn: function(ref) {
                            var values = ref.values
                            var search = ref.search
                            var isOpen = ref.isOpen
                            return [
                              values.length && !isOpen
                                ? _c(
                                    "span",
                                    { staticClass: "multiselect__single" },
                                    [
                                      _vm._v(
                                        _vm._s(values.length) +
                                          " options selected"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.filterQuery.coordinator,
                        callback: function($$v) {
                          _vm.$set(_vm.filterQuery, "coordinator", $$v)
                        },
                        expression: "filterQuery.coordinator"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-group add-new__global_search" },
                  [
                    _c(
                      "b-button",
                      {
                        ref: "ALCreatedDate",
                        staticClass: "ml-2 header-filter-btns",
                        attrs: { variant: "theme", id: "ALCreatedDate" },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape"
                              ])
                            ) {
                              return null
                            }
                            return _vm.$refs.ALCreatedDatePopover.$emit("close")
                          },
                          click: function($event) {
                            _vm.ALCreatedDatePopover = !_vm.ALCreatedDatePopover
                          }
                        }
                      },
                      [
                        _vm._v("\n              Created Date\n              "),
                        _c("i", {
                          staticClass: "far fa-calendar-check text-primary"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "ALCreatedDatePopover",
                        attrs: {
                          show: _vm.ALCreatedDatePopover,
                          target: "ALCreatedDate",
                          triggers: "click blur",
                          placement: "bottom",
                          "custom-class":
                            "filter_popover__gs created-date-popover"
                        },
                        on: {
                          "update:show": function($event) {
                            _vm.ALCreatedDatePopover = $event
                          }
                        }
                      },
                      [
                        _c("date-range-picker", {
                          ref: "pickerDateCreated",
                          attrs: {
                            opens: "inline",
                            autoApply: true,
                            ranges: _vm.customCreatedDateRanges
                          },
                          on: { update: _vm.onUpdateDateCreated },
                          model: {
                            value: _vm.filterQuery.dateCreatedRange,
                            callback: function($$v) {
                              _vm.$set(_vm.filterQuery, "dateCreatedRange", $$v)
                            },
                            expression: "filterQuery.dateCreatedRange"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-form-group", [
                  _vm.isMobile()
                    ? _c(
                        "div",
                        { staticClass: "mobile__date__triggers" },
                        [
                          _c("multiselect", {
                            ref: "dateFilterTrigger",
                            attrs: {
                              options: _vm.dateTriggers,
                              "show-labels": false,
                              multiple: false,
                              "allow-empty": false,
                              "open-direction": "bottom"
                            },
                            on: { input: _vm.setDateTriggerMobile },
                            model: {
                              value: _vm.triggerSelected,
                              callback: function($$v) {
                                _vm.triggerSelected = $$v
                              },
                              expression: "triggerSelected"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isMobile()
                    ? _c("div", [
                        _c(
                          "label",
                          { staticClass: "btn-theme date-filter-triggers" },
                          [
                            _c(
                              "b-form-radio",
                              {
                                ref: "today",
                                staticClass: "csm-checkbox",
                                attrs: {
                                  id: "today",
                                  value: "today",
                                  name: "createdDateTrigger"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.filterQuery.filterByDateCreated = true
                                    _vm.filterQuery.dateCreatedRange.startDate = _vm
                                      .$moment()
                                      .format()
                                    _vm.filterQuery.dateCreatedRange.endDate = _vm
                                      .$moment()
                                      .format()
                                  }
                                },
                                model: {
                                  value: _vm.triggerSelected,
                                  callback: function($$v) {
                                    _vm.triggerSelected = $$v
                                  },
                                  expression: "triggerSelected"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  Today\n                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "btn-theme ml-2 date-filter-triggers"
                          },
                          [
                            _c(
                              "b-form-radio",
                              {
                                ref: "weekly",
                                staticClass: "csm-checkbox",
                                attrs: {
                                  id: "weekly",
                                  value: "weekly",
                                  name: "createdDateTrigger"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.filterQuery.filterByDateCreated = true
                                    _vm.filterQuery.dateCreatedRange.startDate = _vm
                                      .$moment()
                                      .startOf("week")
                                      .format()
                                    _vm.filterQuery.dateCreatedRange.endDate = _vm
                                      .$moment()
                                      .endOf("week")
                                      .format()
                                  }
                                },
                                model: {
                                  value: _vm.triggerSelected,
                                  callback: function($$v) {
                                    _vm.triggerSelected = $$v
                                  },
                                  expression: "triggerSelected"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  This Week\n                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
              ],
              1
            ),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.filterQuery.query = ""
                            _vm.searchQuery = ""
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.filterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.coordinator, function(coordinator) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-5 col-md-4 col-4 text-right right-side" },
            [
              _c(
                "div",
                { staticClass: "logo-user" },
                [
                  _c("HeaderNotification"),
                  _vm._v(" "),
                  _c("LoggedInUser"),
                  _vm._v(" "),
                  _c("Logo")
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }